/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDetailsPanelInfoStyles = makeStyles(theme => ({
  root: {
    padding: '15px',
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-8px',
  },
  column: {
    padding: '8px',
    flex: '1 0 50%',
    minWidth: '300px',
  },
  line: {
    color: theme.palette.text.primary,
    marginTop: '10px',

    '&:first-child': {
      marginTop: '0',
    },

    '& span': {
      margin: '0 0 0 5px',
    },
  },
  linesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -5px',

    marginTop: '10px',

    '&:first-child': {
      marginTop: '0',
    },

    '& > $line': {
      paddingLeft: '5px',
      paddingRight: '5px',
      marginTop: '0',
    },
  },
}));
